/* One complimentary guide per cart. All theme cart changes share this queue. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.createDruzelCart = factory;
})(typeof window !== 'undefined' ? window : this, function ({ request, guideId, root = '/', lock }) {
  let queue = Promise.resolve();
  const isGuide = item => Number(item.variant_id || item.id) === Number(guideId);
  async function api(path, body) {
    const options = { headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (body !== undefined) {
      options.method = 'POST';
      if (typeof FormData !== 'undefined' && body instanceof FormData) options.body = body;
      else {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(body);
      }
    }
    const response = await request(root + path, options);
    if (!response.ok) throw new Error('Your bag could not be updated. Please try again.');
    return response.json();
  }
  const hasPaidProduct = cart => cart.items.some(item => !isGuide(item) && item.final_line_price > 0);
  async function ensureGuide() {
    let cart = await api('cart.js');
    if (!guideId) return cart;
    let guides = cart.items.filter(isGuide);
    if (!hasPaidProduct(cart)) {
      if (guides.length) {
        cart = await api('cart/update.js', {
          updates: Object.fromEntries(guides.map(item => [item.key, 0]))
        });
      }
      return cart;
    }
    if (!guides.length) {
      await api('cart/add.js', { items: [{ id: guideId, quantity: 1 }] });
      cart = await api('cart.js');
      guides = cart.items.filter(isGuide);
    }
    if (!guides.length) throw new Error('Your complimentary guide could not be added. Please try again.');
    if (guides.some(item => item.final_line_price !== 0)) {
      // Never silently add a charge if the guide's catalog price changes.
      await api('cart/update.js', { updates: Object.fromEntries(guides.map(item => [item.key, 0])) });
      throw new Error('The complimentary guide is temporarily unavailable. Please contact Druzél.');
    }
    if (guides.length !== 1 || guides[0].quantity !== 1) {
      cart = await api('cart/update.js', {
        updates: Object.fromEntries(guides.map((item, index) => [item.key, index === 0 ? 1 : 0]))
      });
    }
    return cart;
  }
  function run(operation) {
    const task = async () => { if (operation) await operation(); return ensureGuide(); };
    const result = queue.catch(() => {}).then(() => lock ? lock(task) : task());
    queue = result;
    return result;
  }
  return {
    isGuide,
    hasPaidProduct,
    sync: () => run(),
    add: body => run(() => api('cart/add.js', body)),
    remove: key => run(() => api('cart/change.js', { id: key, quantity: 0 })),
    update: updates => run(() => api('cart/update.js', { updates }))
  };
});
